import { NgTemplateOutlet } from '@angular/common';
import {
  afterNextRender,
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  OnDestroy,
  OnInit,
  signal,
} from '@angular/core';
import { VideoGrid } from '@components/video-grid/model';
import { AnchorService } from '@services/anchor';
import { ResponsiveService } from '@services/responsive';
import { TitleComponent } from '@shared/components/title';
import { Title } from '@shared/components/title/model';
import { VideoComponent } from '@shared/components/video';
import { getId } from '@shared/utils';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-video-grid',
  imports: [VideoComponent, TitleComponent, NgTemplateOutlet],
  providers: [AnchorService],
  templateUrl: './video-grid.component.html',
  styleUrl: './video-grid.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VideoGridComponent implements OnInit, OnDestroy {
  @Input() data!: VideoGrid;
  readonly idComponent = `video-grid-${getId()}`;
  breakpoints = inject(ResponsiveService).breakpoints;
  title = signal<Title>(null!);
  readonly #anchorService = inject(AnchorService);
  #destroy$: Subject<boolean> = new Subject<boolean>();

  constructor() {
    afterNextRender(() => {
      void this.#anchorService
        .monitorUrlAnchor('partenaires', this.idComponent)
        .pipe(takeUntil(this.#destroy$))
        .subscribe();
    });
  }

  ngOnInit(): void {
    this.title.set({
      size: {
        desktop: 'H3',
        mobile: 'H2',
      },
      text: this.data.title,
      align: {
        mobile: 'CENTER',
        desktop: 'CENTER',
      },
      level: 'SPAN',
      color: 'WHITE',
    });
  }

  ngOnDestroy(): void {
    this.#destroy$.next(true);
    this.#destroy$.complete();
  }
}
